// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"styles_innerContainer__Fv6Zm","infoText":"styles_infoText__zMmwD","titleText":"styles_titleText__Qj0Cr"};